import type { RouteObject } from 'react-router-dom';

/**
 * Public auth routes. `/login` is super-admin (username + password); `/login/otp`
 * is reserved for staff (phone + OTP) when those APIs exist.
 */
export const authRoutes: RouteObject[] = [
  {
    path: 'login',
    async lazy() {
      const { AdminLoginPage } = await import('./pages/AdminLoginPage');
      return { Component: AdminLoginPage };
    },
    handle: { title: 'auth:login.adminTitle' },
  },
  {
    path: 'login/otp',
    async lazy() {
      const { StaffOtpLoginPage } = await import('./pages/StaffOtpLoginPage');
      return { Component: StaffOtpLoginPage };
    },
    handle: { title: 'auth:login.otp.title' },
  },
];
